import { cn } from '@gyym/ui'

import { TwoColumnLayout } from '@/components/Layouts/legacy/TwoColumnLayout'
import { CorpLpBanner } from '@/components/UI/CorpLpBanner'
import {
  useInitialProfileRegistrationEffect,
  useVerifyEmailEffect,
} from '@/modules/Auth'
import { useMapFacilities } from '@/modules/Facilities'
import { useSearchPageMeta } from '@/modules/FacilitySearch'
import { formatNumber } from '@/utils/formatNumber'

import { LeftContent } from './LeftContent'
import { RightContent } from './RightContent'
import { SearchProvider, useSearch } from './SearchProvider'
import { useSearchFacilities } from './useSearchFacilities'

const Content = () => {
  // Verify email
  useVerifyEmailEffect()

  // Register initial profile
  useInitialProfileRegistrationEffect()

  const { isMapView, searchParams } = useSearch()

  // RightContent と同一の SWR キーで取得 (共有されるので追加リクエストは発生しない)
  const { data: { meta } = {} } = useSearchFacilities()

  const { meta: mapMeta } = useMapFacilities(
    searchParams ?? {},
    // fetch if map view
    isMapView,
  )

  const {
    pageMeta: { heading, ...pageMeta },
    prevPage,
    isSearchResult,
    getParagraph,
  } = useSearchPageMeta(searchParams)

  return (
    <TwoColumnLayout
      {...pageMeta}
      heading={heading}
      paragraph={
        meta
          ? getParagraph(meta.total)
          : mapMeta
          ? getParagraph(mapMeta.total)
          : ''
      }
      subheading={
        meta
          ? `${formatNumber(meta.total)}件`
          : mapMeta
          ? `${formatNumber(mapMeta.total)}件`
          : ''
      }
      tabletFullscreen={isMapView}
      leftContent={<LeftContent />}
      bottomContent={
        <CorpLpBanner
          placement="search_bottom"
          className={cn(
            'mx-auto max-w-screen-pc',
            // 地図表示中はフッター同様にタブレット以下では隠す
            isMapView && 'hidden pc:block',
          )}
        />
      }
    >
      <RightContent
        heading={heading}
        prevPage={prevPage}
        isSearchResult={isSearchResult}
      />
    </TwoColumnLayout>
  )
}

export const FacilitySearchView = { SearchProvider, Content }
